/**
 * 上传文件 button
 */
import React, { useContext, useEffect, useState, useMemo, useCallback, ReactChild } from "react";
import { Button, Upload, message } from "antd";

import { UploadControlCenterInstance, joyspaceKey } from "@/components/UploadBox/UploadControl";
import {
  groupJoyspaceKey,
  GroupUploadControlCenterInstance
} from "@/components/Joyspace/components/GroupUploadPanel/UploadController";
import { UploadFile } from "./types";
import context, { useTranslation } from "../../context";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import events from "../../context/events";
import { notUseJoySpaceOffline } from "../../util";
import { debounce } from "lodash";
import { analysisLog } from "@/utils/logAnalytics";
import { handleUploadFolder } from "./util";

export interface OwnProps {
  className?: string;
  fromPage?: string;
  categoryId?: string;
  onUploadFile?: (result: any) => void;
  teamId?: string;
  folderId?: string;
  spaceId?: string;
  projectId?: string;
  archive?: boolean;
  gid?: string;
  from?: string;
  children?: ReactChild;
}

export interface OwnState {
  ProgressHandler: null;
}

type IProps = Readonly<OwnProps>;

function UploadFolderButton(props: IProps) {
  const lang = useTranslation();
  const {
    fromPage,
    onUploadFile,
    archive = false,
    gid,
    folderId,
    spaceId,
    projectId,
    from = ""
  } = props;
  const uploadControlInstance = gid
    ? GroupUploadControlCenterInstance.get(groupJoyspaceKey) ||
      GroupUploadControlCenterInstance.register(groupJoyspaceKey, true, gid)
    : UploadControlCenterInstance.get(joyspaceKey);
  const [disabled, setDisabled] = useState(false);
  const { appRuntimeEnv, onLine } = useContext<GlobalContextConfig>(GlobalContext);

  useEffect(() => {
    if (notUseJoySpaceOffline()) {
      return;
    }
    setDisabled(!onLine);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onLine]);

  const handleAddFolderClick = () => {
    const input = document.createElement("INPUT");
    input.setAttribute("type", "file");
    input.setAttribute("webkitdirectory", "webkitdirectory");
    input.setAttribute("directory", "directory");
    input.onchange = (ev: any) => {
      analysisLog("xtbg_jzb_joyspace_home_1676548210761", "46", "click", from);
      handleUploadFolder(ev.target.files, {
        gid,
        appRuntimeEnv,
        folderId,
        uploadControlInstance,
        spaceId
      });
    };
    input.click();
  };

  return (
    <div className="ant-upload-custom">
      <Button
        onClick={() => {
          if (archive || disabled) {
            return;
          }
          handleAddFolderClick();
        }}
        type="default"
        disabled={archive || disabled}
        clstag="pageclick|keycount|focus_joyspace_01_1615797631505|4"
      >
        {props.children}
        {lang("myspace.uploadFolder")}
      </Button>
    </div>
  );
}

export default UploadFolderButton;
